<template>
  <div id="app" class="index" :style="{
    transform: `rotate(${verticalVisible ? 0 : 270}deg) scale(1,1)`,
    height: `${verticalVisible ? 'auto' : '100vmin'}`,
    'transform- origin': 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    'touch-action': `${verticalVisible ? 'pan-y' : 'pan-x'}`
  }">
    <Start v-if="showType === 'start'" :verticalVisible="verticalVisible" :playing="playing" @playAudio="playAudio"
      @endAudio="endAudio" @fullClick="fullClick" />
    <Index v-if="showType === 'index'" @startClick="startClick" />
    <BeforeStart v-if="showType === 'before'" @startClick="startClick" />
    <audio ref="dradio" class="mp3" id="d" autoplay loop :src="music"></audio>
  </div>
</template>

<script>
import Index from './view/index.vue'
import Start from './view/start.vue'
import BeforeStart from './view/beforeStart.vue'
import { getwxSign2 } from '@/assets/homeapi.js';
import music from '@/assets/music.mp3'

export default {
  name: "App",
  components: { Index, Start, BeforeStart },
  data() {
    return {
      music,
      showBefore: false,
      showPop: false,
      verticalVisible: true,
      height: '100%',
      width: '100%',
      showType: 'index',
      scroll: 0,
      showStart: false,
      scrollPosition: [0, 0],
      playing: false,
    };
  },
  watch: {
    width(newValue, oldValue) {
      if (this.scrollPosition[0] > 0 || this.scrollPosition[1] > 0) {

      } else {
        let scale = 1;
        if (typeof oldValue === 'number') {
          scale = newValue / oldValue;
        }
        const x = this.verticalVisible ? 0 : this.scroll;
        const y = this.verticalVisible ? this.scroll : 0;
        window.scrollTo(x * scale, y * scale)
      }
    }
  },
  methods: {
    endAudio() {
      this.$refs.dradio.pause();
      this.playing = false;
    },
    isIos() {
      var browser = {
        versions: (function () {
          var u = navigator.userAgent;
          return {
            trident: u.indexOf("Trident") > -1,
            presto: u.indexOf("Presto") > -1,
            webKit: u.indexOf("AppleWebKit") > -1,
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
            mobile: !!u.match(/AppleWebKit.*Mobile.*/),
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
            iPhone: u.indexOf("iPhone") > -1,
            iPad: u.indexOf("iPad") > -1,
            webApp: u.indexOf("Safari") == -1,
            uc:
              (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) &&
              u.indexOf("UCBrowser") > -1,
            weixin: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger", //判断微信
            iosApp: u.match(/ByIphone/i) != null, //判断ios版app
            androidApp: u.match(/ByAndroid/i) != null, //判断android版app
            iPhoneOs:
              u.indexOf("iPhone") > -1 && u.indexOf("Mobile") > -1
                ? /CPU (?:iPhone )?OS (\d+_\d+)/.test(u)
                  ? parseFloat(RegExp.$1.replace("_", "."))
                  : 2
                : null, //返回ios版本号
          };
        })(),
      };
      return browser.versions.ios;
    },
    playAudio() {
      if (!this.playing) {
        // console.log(this.isIos())
        // if (this.isIos()) {
        //   this.$refs.dradio.load(); // iOS 9   还需要额外的 load 一下, 否则直接 play 无效
        // }
        this.$refs.dradio.play();
        if (this.isIos()) {
          this.audioAutoPlay('d');
        }
        this.playing = true;
      }
    },
    audioAutoPlay(id){
        var audio = document.getElementById(id),
            play = function(){
                audio.play();
                document.removeEventListener("touchstart",play, false);
            };
        audio.play();
        document.addEventListener("WeixinJSBridgeReady", function () {
            play();
        }, false);
        document.addEventListener('YixinJSBridgeReady', function() {
            play();
        }, false);
        document.addEventListener("touchstart",play, false);
        this.playing = true;
    },
    fullClick(scrollPosition) {
      this.scrollPosition = scrollPosition;
    },
    startClick(type) {
      // this.showStart = true;
      this.playAudio()
      this.showType = type
    },
    getIndex() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      const srcollX = window.scrollX;
      const scrollY = window.scrollY;
      this.scroll = Math.max(srcollX, scrollY)
      this.width = Math.min(width, height)
      this.height = Math.max(width, height)
      if (!this.showPop) {
        this.verticalVisible = width < height;
      }
      // this.$nextTick(() => {
      //   const x = this.verticalVisible ? 0 : this.scroll;
      //   const y = this.verticalVisible ? this.scroll : 0;
      //   window.scrollTo(x, y)
      // })
    },
    async configwx() {
      var url = location.href.split("#")[0];
      url = window.entryUrl;
      const ret = await getwxSign2({
        url: encodeURIComponent(url),
      });
      const { appId, timestamp, nonceStr, signature } = ret.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名
        jsApiList: ["wx-open-launch-app", "checkJsApi", "updateAppMessageShareData", "updateTimelineShareData", 'chooseImage', 'previewImage'],
        openTagList: ["wx-open-launch-app"],
      });

      wx.ready(() => {
        console.log("wx准备完成");
        let tit = '重庆丰都长江村：长江岸上好风光 幸福生活入画来';
        let pic = 'http://zjy-web-cdn.bigdatajy.com/fengduLong/static/img/share.png';
        let desc = '江阴市融媒体中心联动长江沿线媒体寻访长江村，讲述小家变迁，展现大国成就。';
        let fxUrl = 'http://zjy-web-cdn.bigdatajy.com/fengduLong/index.html';
        // 分享微信朋友圈
        wx.updateAppMessageShareData({
          link: fxUrl,
          desc: desc,
          title: tit,
          imgUrl: pic,
          success: function () {
            // 分享成功可以做相应的数据处理
            console.log("分享成功");
          },
        });
        // 分享给朋友
        wx.updateTimelineShareData({
          title: tit,
          desc: desc,
          imgUrl: pic,// 分享图标
          link: fxUrl,
          success: () => {
            console.log("分享成功");
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            console.log('您取消了分享');
          }
        });
        wx.checkJsApi({
          jsApiList: ["checkJsApi"],
          success: function (res) {
            console.log("checkJsApi");
            // console.log(res);
          },
        });
      });

      wx.error(function (res) {
        console.log("--失败--"); // 必填，接口调用失败的错误信息
        console.log(res);
      });
    },
    getQueryParam (name){
      let url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      let results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  },
  created() {
    this.getIndex()
    // 定义最大的 fontSize
    // const MAX_FONT_SIZE = this.verticalVisible ? 37.5 : 37.5;
    // 监听 HTML 文档被解析完成的事件
    document.addEventListener("DOMContentLoaded", () => {
      // 获取html标签
      // const html = document.querySelector("html");
      // // 屏幕的宽度除以10，获取跟元素fontSize标准
      // let fontSize = window.innerWidth / 10;
      // // 获取到的 fontSize 标准不允许超过我们定义的最大值
      // fontSize = fontSize > MAX_FONT_SIZE ? MAX_FONT_SIZE : fontSize;
      // // 定义根元素 大小
      // html.style.fontSize = fontSize + "px";
      this.getIndex();
    });
    this.showType=this.getQueryParam('showType') || 'index';
  },
  mounted() {
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
      window.entryUrl = document.location.href.split('#')[0];
    }
    window.addEventListener(
      "resize",
      () => {
        // const MAX_FONT_SIZE = this.verticalVisible ? 37.5 : 37.5;
        // //监听横竖屏切换
        // const html = document.querySelector("html");
        // // 屏幕的宽度除以10，获取跟元素fontSize标准
        // let fontSize = window.innerWidth / 10;
        // // 获取到的 fontSize 标准不允许超过我们定义的最大值
        // fontSize = fontSize > MAX_FONT_SIZE ? MAX_FONT_SIZE : fontSize;
        // // 定义根元素 大小
        // html.style.fontSize = fontSize + "px";
        this.getIndex();
      },
      false
    );
    this.getIndex();
    this.configwx()
  },
  beforeDestroy() {
    this.endAudio()
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

.container {
  width: 100%;
  margin: 0 auto;
  max-width: 992px;
  /* no */
}

.mp3 {
  width: 0;
  height: 0;
  position: absolute;
  top: 0;
  left: 0;
}


p,
div,
span {
  font-size: 16px;
}

img {
  display: block;
}

.w-100 {
  width: 100%;
}

.flex {
  display: flex;
}
</style>
<style lang="scss">
.item {
  width: 100vmin;
  height: 100vmax;
}

.op1 {
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue